import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Card, CardBody, Col, Container,  Row } from "reactstrap";
 import { UserListTableData } from "../../../../data/users/UsersList";
import { Link } from "react-router-dom";
import { H5, Image, SVG, Badges, H3 } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../service";
import { MoreVertical } from "react-feather";
import {DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown,} from "reactstrap";
import { UserListTableDataColumnType } from "../../../../types/users/UserTypes";
import { showWarningAlert } from "../../../../utils/showWarningAlert";
 import CommonModal from "../../../modal/common/CommonModal";
import UserResetPassword from "../../../modal/common/user-reset-password/UserResetPassword";
import Breadcrumbs from "../../../../common-elements/breadcrumbs/Breadcrumbs";
import FilterSearchSection from "../../../common/filter-section/FilterSearchSection";
 
function UserAdminListContainer() {
  const { t } = useTranslation();
  

  // Double the data for demo purposes
  const doubledData = [...UserListTableData, ...UserListTableData];

  // State to keep track of how many users to show
  const [visibleCount, setVisibleCount] = useState(8);

  // Handler to load more users on scroll
  const handleScroll = () => {
    if (
      window.innerHeight + window.scrollY >= document.body.offsetHeight - 100
    ) {
      setVisibleCount((prev) => Math.min(prev + 2, doubledData.length));
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // UserList Actions like view,edit,delete

  const UserListTableAction: React.FC<{ row: UserListTableDataColumnType }> = ({
    row,
  }) => {
    const { t } = useTranslation();
    const [selectedUser, setSelectedUser] = useState<UserListTableDataColumnType | null>(null);
  console.log(selectedUser);
  
  const [staticModal, setStaticModal] = useState(false);
  const staticModalToggle = () => {
    setStaticModal(!staticModal);
    setSelectedUser(row);
  }

    const handleBlock = () => {
      showWarningAlert({
        title: t("Are you sure?"),
        text: `Do you want to block ${row.name}?`,
        confirmButtonText: t("Block"),
        onConfirm: () => {
          // Block logic here
        },
      });
    };

    const handleUnblock = () => {
      showWarningAlert({
        title: t("Are you sure?"),
        text: `Do you want to unblock ${row.name}?`,
        confirmButtonText: t("Unblock"),
        onConfirm: () => {
          // Unblock logic here
        },
      });
    };

    return (
      <UncontrolledDropdown>
        <DropdownToggle tag="span" className="cursor-pointer">
          <MoreVertical size={18} />
        </DropdownToggle>
        <DropdownMenu>
          <Link
            to={`${process.env.PUBLIC_URL}/users/organization-admin/view/${row.id}`}
          >
            <DropdownItem>{t("View")}</DropdownItem>
          </Link>

          <Link
            to={`${process.env.PUBLIC_URL}/users/organization-admin/edit/${row.id}`}
          >
            <DropdownItem>{t("Edit")}</DropdownItem>
          </Link>
          {row.status === "Active" ? (
            <DropdownItem onClick={handleBlock}>{t("Block")}</DropdownItem>
          ) : (
            <DropdownItem onClick={handleUnblock}>{t("Unblock")}</DropdownItem>
          )}
           <DropdownItem onClick={staticModalToggle}>
           {t("Reset Password")}
          </DropdownItem>
          <Link
            to={`${process.env.PUBLIC_URL}/users/organization-admin/activity-logs/${row.id}`}
          >
          <DropdownItem >
           {t("ActivityLog")} 
          </DropdownItem>
          </Link>
          <Link
            to={`${process.env.PUBLIC_URL}/users/organization-admin/user-access-rights/${row.id}`}
          >
          <DropdownItem >
           {t("AccessRights")}
          </DropdownItem>
          </Link>
        </DropdownMenu>
        <CommonModal backdrop="static"  modalBodyClassName="social-profile text-start" isOpen={staticModal} toggle={staticModalToggle} >
        <H3 className="modal-header justify-content-center border-0"> 
          <span className="font-primary email_add_0">{selectedUser?.organizationname}</span></H3>
            <div className="modal-toggle-wrapper">
              <UserResetPassword staticModalToggle={staticModalToggle} data={selectedUser}/>
            </div>
        </CommonModal>
      </UncontrolledDropdown>
    );
  };

  return (
    <>
      <Breadcrumbs mainTitle={t("organizationAdmin")} parent={t("Users")} />
      <Container fluid>
        {/* Add Filter Annd search section  */}
        <FilterSearchSection />
        
         {/* List the users */}
        <Row>
          {doubledData.slice(0, visibleCount).map((item) => (
            <Col
              xl="4"
              sm="6"
              xxl="3"
              className="col-ed-4 box-col-4"
              key={item.id + '-' + item.name + '-' + Math.random()}
            >
              <Card className="social-profile">
                <CardBody>
                  <div className="social-img-wrap">
                    <div className="social-img">
                      <Image src={dynamicImage(item.image)} alt="user" />
                    </div>
                    <div className="edit-icon">
                      <SVG iconId="profile-check" />
                    </div>
                  </div>
                  <div style={{ position: "absolute", top: 10, right: 10 }}>
                    <UserListTableAction row={item} />
                  </div>
                  <div className="social-details">
                    <H5 className="mb-1">
                      <Link to="">{item.name}</Link>
                    </H5>
                  </div>
                  <div className="social-details">
                    <H3 className="mb-1">
                      <Link to="">{item.organizationname}</Link>
                    </H3>
                  </div>
                  <Badges
                    color="transparent"
                    className={`badge-light-${
                      item.status === "Inactive" ? "secondary" : "success"
                    }`}
                  >
                    {item.status}
                  </Badges>
                  <hr />
                  <div className="social-details">
                    <H5 className="mb-1 d-flex align-items-center gap-2">
                      <i className="fa fa-phone" />
                      <Link to="">{item.phonenumber}</Link>
                    </H5>
                    <H5 className="mb-1 d-flex align-items-center gap-2">
                      <i className="fa fa-envelope" />
                      <span className="f-light"> {item.email}</span>
                    </H5>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
}

export default UserAdminListContainer;
